
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Oler"
              description="Car Rental System (MERN Stack) is a web application that allows users to browse cars, book rentals online, and manage bookings. It includes user authentication, an admin dashboard for vehicle and booking management, and a responsive interface built with MongoDB, Express.js, React.js, and Node.js."
              ghLink="https://github.com/avid-coder234/carrental"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="ProctorAI Lite"
              description="Cheating Surveillance System is a computer vision–based application that detects potential cheating during online exams or interviews by monitoring head pose and eye movements in real time. Built using Python, OpenCV, and dlib’s Shape Predictor 68"
              ghLink="https://github.com/avid-coder234/ProctorAI-Lite"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Nuanced Sentiment Detection"
              description="Sarcasm Detection System is a Streamlit-based NLP application that classifies text as sarcastic or non-sarcastic using ML. It applies advanced text preprocessing, TF-IDF vectorization, and an imbalanced-learning approach (EasyEnsembleClassifier) to improve accuracy. The system supports real-time text input, CSV batch prediction, and detailed evaluation metrics through an interactive web interface."
              ghLink="https://github.com/avid-coder234/NuancedSentimentDetection"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Spotube Analysis"
              description="Spotify–YouTube Data Analysis Project is a data analytics and visualization project that explores the relationship between music performance on Spotify and YouTube. Using Python libraries such as Pandas, NumPy, Matplotlib, and Seaborn, the project cleans and preprocesses the dataset, analyzes key metrics like views, likes, comments, streams,"
              ghLink="https://github.com/avid-coder234/SpotifyAndYoutubeAnalysis"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="AI Prompt Agent"
              description="Prompt-Driven Email Productivity Agent is a Python and Streamlit–based intelligent assistant that automates email management tasks such as categorization, action-item extraction, summarization, and reply drafting. Its behavior is fully controlled through user-editable prompts, ensuring flexibility and transparency."
              ghLink="https://github.com/avid-coder234/emailagent"
              // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley" <--------Please include a demo link here
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Face Recognition and Emotion Detection"
              description="E-commerce Product Recommender with LLM Explanations is a FastAPI-based backend that generates personalized product recommendations using collaborative filtering and enhances them with AI-generated, human-like explanations via Google Gemini, delivering clear and explainable suggestions through a RESTful API."
              ghLink="https://github.com/avid-coder234/EcommerceRecommender"
              // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here 
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
